<template>
  <footer class="footer">
    <div class="footer__wrap">
      <div class="footer__info">
        <img class="footel__img-bitcat" src="https://solanabitcat.com/data/smallcat.png" alt="BITCAT">
        <nav class="footer__social">
          <a href="https://x.com/bitcat_sol_" target="_blank" class="footer__social-link footer__social-link_x"></a>
          <a href="https://t.me/SolanaBitcat" target="_blank" class="footer__social-link footer__social-link_telegram"></a>
        </nav>
      </div>

      

      <div class="footer__section">
        <nav>
          <router-link to="/leaderboard">Leaderboard</router-link>
          <router-link to="/roadmap">Roadmap</router-link>
          <router-link to="/changelog">Changelog</router-link>
        </nav>
        <span class="footer__copy">BITCAT <span class="footer__copy_heart">♥</span> Community</span>
      </div>
    </div>
  </footer>
</template>

<style>
  .footer {
    display: flex;
    justify-content: center;
    padding: 12px 10px 10px;
    background: rgb(215, 77, 36);
  }

  .footer__wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-end;
    max-width: 1200px;
    width: 100%;
  }

  .footer__info {
    display: flex;
    gap: 10px;
    align-items: flex-end;
  }

  .footel__img-bitcat {
    display: flex;
  }

  .footer__section {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    align-items: center;
    margin-top: 10px;
  }

  .footer__section nav {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
  }

  .footer__section nav a {
    color: #fff;
    text-decoration: none;
  }

  .footer__section nav a.router-link-active {
    text-decoration: underline;
  }

  .footer__section nav a:hover {
    text-decoration: underline;
  }

  .footer__copy {
    font-size: 1.2em;
    cursor: pointer;
  }

  @keyframes heartFadeInOut {
    0% { opacity: 0; }
    50% { opacity: 1; }
    100% { opacity: 0; }
  }

  .footer__copy:hover > .footer__copy_heart {
    animation: none;
    color: #fff;
  }

  .footer__copy_heart {
    animation: heartFadeInOut 2s infinite;
    color: #fff;
  }

  .footer__social {
    display: flex;
    gap: 15px;
    align-items: center;
  }

  .footer__social-link {
    width: 35px;
    height: 35px;
    display: block;
    margin-bottom: 4px;
    background-image: url('@/assets/social-media-icons.jpg');
    background-size: 280px;
    background-repeat: no-repeat;
    opacity: 0.8;
    transition: opacity 0.3s ease;
    border-radius: 50%;
  }

  .footer__social-link:hover {
    opacity: 1;
  }

  .footer__social-link_x {
    background-position: -105px -17px;
  }

  .footer__social-link_telegram {
    background-position: -209px -17px;
  }
</style>